import { buildEntityLoadingState, EntityLoadingState } from '../EntityState';

export type UserBugReportState = EntityLoadingState & {};

export const buildUserBugReportState = (
  data: Partial<UserBugReportState> = {},
) => {
  return {
    ...buildEntityLoadingState(data),
  };
};
